import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static classes = ["hidden"];
  static values = {
    offset: { type: Number, default: 80 },
    tolerance: { type: Number, default: 6 },
    revealNearTopOnly: { type: Boolean, default: false },
  };

  connect() {
    this.lastScrollY = window.scrollY;
    this.ticking = false;
    this.reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    window.addEventListener("scroll", this.onScroll, { passive: true });
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll);
  }

  onScroll = () => {
    if (this.ticking) return;
    this.ticking = true;
    window.requestAnimationFrame(this.update);
  };

  update = () => {
    this.ticking = false;
    const currentScrollY = window.scrollY;
    const delta = currentScrollY - this.lastScrollY;

    if (Math.abs(delta) < this.toleranceValue) return;

    const scrollingUp = delta < 0;
    const nearTop = currentScrollY <= this.offsetValue;
    const revealsOnScrollUp = scrollingUp && !(this.revealNearTopOnlyValue && !nearTop);

    if (revealsOnScrollUp || nearTop || this.menuOpen) {
      this.reveal();
    } else {
      this.conceal();
    }

    this.lastScrollY = currentScrollY;
  };

  reveal() {
    this.element.classList.remove(...this.hiddenClasses);
  }

  conceal() {
    if (this.reducedMotion) return;
    this.element.classList.add(...this.hiddenClasses);
  }

  get menuOpen() {
    return Array.from(
      this.element.querySelectorAll("[data-visibility-target]"),
    ).some((panel) => !panel.classList.contains("hidden"));
  }
}
